import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/commandment.pdf'; 
import { Helmet } from 'react-helmet';

function Springs() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>S&#228;mtliche schriften und briefe series IV volume 7</var><br />
        Deutsche Akademie der Wissenschaften (ed)<br />
        p 830<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: May - June 1685 (?)<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (138k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On the Commandment of Love, Schism, and the Principles of the Church</title>
            <meta name="description" content="An English translation of ON THE COMMANDMENT OF LOVE, SCHISM, AND THE PRINCIPLES OF THE CHURCH by Gottfried Wilhelm Leibniz, from May - June 1685 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON THE COMMANDMENT OF LOVE, SCHISM, AND THE PRINCIPLES OF THE CHURCH</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A IV 7, 830</b>]<br /><br />
                The commandment of love<a name="1" href="#note1"><sup>1</sup></a> is the highest.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Schism is very much opposed to love.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The safest dogma is that the Catholic Church was founded by God, to be heard by all, never to perish, never to be obscured, never to be forsaken.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This principle was also held as most certain in the ancient Church, and is held even now by Eastern Churches; but the principles of Protestants are unknown to established Churches in other regions of the world.<a name="2" href="#note2"><sup>2</sup></a>

                        <br /><br /><br />
                <hr className='rightcol-hr' />
                        <br /><br />
                        NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> See Matthew 22.36-40 and Mark 12.28-31.<br />
                        <a name="note2" href="#2">2.</a> Cf. A IV 3, 292.
                <br /><br /><br />
                        &#169; Lloyd Strickland 2021
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Springs;
